import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Form } from '@/components/functional/Form/Form';
import { RfpProConfirmPublicList } from '@/components/modules/pages/rfp/professional/List/RfpProConfirmList/RfpProConfirmPublicList';
import { RfpProOfferConfirmModal } from '@/components/modules/pages/rfp/professional/Modal/RfpProOfferConfirmModal';
/**
 * コンサルタント案件提案提出: 確認内容（公募）
 * @param props
 * @returns
 */
export const RfpProConfirmPublicForm = (props) => {
    const { budget, className = '', customErrorCallback = undefined, hideModal, initialValues: propsInitialValues, isShowConfirmModal, onSubmit, paymentOption, } = props;
    const initialValues = useMemo(() => {
        const offerValues = propsInitialValues.offer;
        return {
            assign: propsInitialValues.assign,
            offer: Object.assign(Object.assign({}, offerValues), { period: typeof offerValues.period === 'string'
                    ? parseInt(offerValues.period, 10)
                    : offerValues.period, price: typeof offerValues.price === 'string'
                    ? parseInt(offerValues.price, 10)
                    : offerValues.price }),
            payment: propsInitialValues.payment,
            rfp_offer_members: propsInitialValues.rfp_offer_members,
        };
    }, [propsInitialValues]);
    return (_jsx(Form, { customErrorCallback: customErrorCallback, initialValues: initialValues, onSubmit: onSubmit, render: ({ form, handleSubmit, submitting, values }) => (_jsxs("form", Object.assign({ className: className, onSubmit: handleSubmit }, { children: [_jsx(RfpProConfirmPublicList, { additionalFiles: values.offer.additional_files, billingInformation: values.payment.billing_information, budget: budget, candidateInterviewDate: values.offer.candidate_interview_date, file: values.offer.file, freeDescription: values.offer.free_description, members: values.rfp_offer_members, options: values.payment.options, paymentOption: paymentOption, period: values.offer.period, price: values.offer.price, summary: values.offer.summary }), _jsx(RfpProOfferConfirmModal, { isShow: isShowConfirmModal, onClickCancel: hideModal, onClickSubmit: form.submit, submitting: submitting })] }))) }));
};
